(() => {
  'use strict';
  const hero = document.querySelector('[data-dm-campaign-hero]');
  if (!hero || hero.dataset.dmCampaignBound) return;
  hero.dataset.dmCampaignBound = 'true';
  const root = document.documentElement;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 990px) and (pointer: fine)');
  const toggle = hero.querySelector('[data-dm-motion-toggle]');
  const photo = hero.querySelector('.dm-campaign-hero__photo');
  const permitted = hero.dataset.motionEnabled !== 'false';
  const selectors = '.dm26-section-head, .dm26-flavour, .dm26-gifting__media, .dm26-gifting__copy, .dm-ux-paths h2, .dm-ux-paths__grid article, .dm-ux-services h2, .dm-ux-services__grid article, .dm-delivery-care__head, .dm-delivery-care__line, .dm26-closing h2, [data-dm-reveal]';
  const targets = [...new Set(document.querySelectorAll(selectors))];
  let saved = false;
  try { saved = sessionStorage.getItem('dm-campaign-motion-paused') === 'true'; } catch (_) {}
  let paused = saved;
  let enabled = false;
  let visible = true;
  let frame = 0;
  let revealObserver;
  function restHero() {
    hero.dataset.dmHeroResting = String(!visible || document.hidden || !enabled);
  }

  function updatePhoto() {
    frame = 0;
    if (!enabled || !visible || !desktop.matches || document.hidden || !photo) return;
    const bounds = hero.getBoundingClientRect();
    const distance = Math.max(-12, Math.min(12, -bounds.top * .025));
    photo.style.setProperty('--dm-campaign-pan', distance + 'px');
  }

  function schedulePhoto() {
    if (enabled && visible && desktop.matches && !document.hidden && !frame) frame = requestAnimationFrame(updatePhoto);
  }

  function showAll() {
    revealObserver?.disconnect();
    targets.forEach(target => {
      target.classList.add('dm-is-visible');
      target.removeAttribute('data-dm-motion-ready');
    });
    if (frame) cancelAnimationFrame(frame);
    frame = 0;
    photo?.style.removeProperty('--dm-campaign-pan');
  }

  function prepareReveals() {
    if (!('IntersectionObserver' in window)) { showAll(); return; }
    revealObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('dm-is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
    targets.forEach(target => {
      target.dataset.dmReveal = '';
      if (target.getBoundingClientRect().top < innerHeight - 24 || target.classList.contains('dm-is-visible')) {
        target.classList.add('dm-is-visible');
      } else {
        target.dataset.dmMotionReady = '';
        const siblings = [...target.parentElement.children];
        target.style.setProperty('--dm-reveal-delay', Math.min(siblings.indexOf(target) * 65, 195) + 'ms');
        revealObserver.observe(target);
      }
    });
  }

  function setMotion(first = false) {
    enabled = permitted && !reduced.matches && !paused && !window.Shopify?.designMode;
    root.dataset.dmCampaignMotion = enabled ? 'on' : 'off';
    restHero();
    if (toggle) {
      toggle.hidden = !permitted || reduced.matches || Boolean(window.Shopify?.designMode);
      toggle.textContent = enabled ? toggle.dataset.pauseLabel : toggle.dataset.resumeLabel;
    }
    if (enabled) {
      if (first) prepareReveals();
      schedulePhoto();
    } else {
      showAll();
    }
  }

  toggle?.addEventListener('click', () => {
    paused = !paused;
    try { sessionStorage.setItem('dm-campaign-motion-paused', String(paused)); } catch (_) {}
    setMotion();
    document.dispatchEvent(new CustomEvent('dm:motion-preference', {detail:{paused}}));
  });
  document.addEventListener('dm:motion-preference', event => {
    paused = event.detail.paused;
    setMotion();
  });
  reduced.addEventListener('change', () => setMotion());
  desktop.addEventListener('change', () => {
    if (!desktop.matches) photo?.style.removeProperty('--dm-campaign-pan');
    schedulePhoto();
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      visible = entries[0].isIntersecting;
      restHero();
      schedulePhoto();
    }).observe(hero);
  }
  window.addEventListener('scroll', schedulePhoto, { passive: true });
  document.addEventListener('visibilitychange', () => { restHero(); schedulePhoto(); });
  document.addEventListener('focusin', event => {
    const target = event.target.closest('[data-dm-reveal]');
    if (target) {
      target.classList.add('dm-is-visible');
      target.removeAttribute('data-dm-motion-ready');
      revealObserver?.unobserve(target);
    }
  });
  setMotion(true);
})();
